import { TIME_ZONE } from 'utils/core/date';
import type { HourMinuteTime } from 'utils/date';
import { formatTimeFromTimezoneToTimezone } from 'utils/date';

type Props = { value: string; timeZone: string };
export function TriggerTimeDisplay({ value, timeZone }: Props) {
  return (
    <>
      {formatTimeFromTimezoneToTimezone(value as HourMinuteTime, timeZone, timeZone)} /
      {formatTimeFromTimezoneToTimezone(value as HourMinuteTime, timeZone, TIME_ZONE)}
    </>
  );
}
